export default function makeMaterialStyle() {
    return {}
}
